import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserIdService } from '../../../../../core/auth';
import { CmsMailFormFieldComponent } from '../../../../../core/model';
import { CmsMailFormFieldsConnector } from '../connectors';

@Injectable({ providedIn: 'root' })
export class CmsMailFormFieldService {
  constructor(private cmsMailFormFieldsConnector: CmsMailFormFieldsConnector, private userIdService: UserIdService) {}

  getCmsMailFormFields(formFields: string): Observable<Array<CmsMailFormFieldComponent>> {
    return this.userIdService
      .takeUserId()
      .pipe(switchMap((userId) => this.cmsMailFormFieldsConnector.getCmsMailFormFields(userId, formFields)));
  }
}
